import {
  Button, Card, CardActions, CardHeader, Divider, Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import React, { Fragment } from 'react';
// import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { PlusCircle } from '../../../../icons/plus-circle';
import STRING_KEYS from '../../../../language/keys';
import ItemsCounter from '../../../../components/ItemsCounter';
import { CONFIG } from '../../../../config';
import { Anchor } from '../../../../components/Anchor';
import { VIEW_MODE } from '../../../../consts/enums';
import TalentEducationItem from './TalentEducationItem';
// import { TalentExperienceItem } from '../TalentExperienceItem';
import { style } from './style';

type Props = {
  educationHistory: EducationHistoryWithId[]
  onDeleteEducationChapter?:(id:string) => void,
  onEducationSelectHandler?: (select: UpdateValues<string | boolean | null | DateObject>,
     id:string) => void,
  onAddNewEducationChapter?: () => void,
  disabled?: boolean,
  viewMode: ViewMode
  onOpenCreateNewEducationModal?: (id:string) => void,
}

const TalentEducation = ({
  educationHistory,
  onEducationSelectHandler = () => { /* noop */ },
  onAddNewEducationChapter,
  onDeleteEducationChapter,
  disabled = false,
  viewMode,
  onOpenCreateNewEducationModal,
}: Props): JSX.Element => {
  const { t: translate } = useTranslation();

  const canAdd = typeof onAddNewEducationChapter === 'function' && viewMode === VIEW_MODE.EDITABLE;

  const cardStyle = {
    ...style.card.style,
    ...(disabled) && style.cardDisabled,
  };

  return (
    <Card sx={ style.card.sx } style={ cardStyle } >
      <Anchor id="education" />
      <CardHeader title={ (
        <Box sx={ style.card.cardHeader.box }>
          <Typography
            variant={ style.card.cardHeader.typography.variant }
            color={ style.card.cardHeader.typography.color }
          >
            {translate(STRING_KEYS.TITLE_EDUCATION)}
          </Typography>
          <ItemsCounter
            counter={ educationHistory.length }
            total={ CONFIG.TALENT_MAX_EDUCATION_ITEMS }
          />
        </Box>
      ) }
      />
      <Divider />
      { educationHistory.map((education:EducationHistoryWithId) => {
        return (
          <Fragment key={ education.id }>
            <TalentEducationItem
              institutionName={ education.institutionName }
              institutionLogo={ education.institutionLogo }
              id={ education.id }
              badges={ education.badges }
              degree={ education.degree || '' }
              fieldOfStudy={ education.fieldOfStudy || '' }
              disabled={ disabled }
              onDeleteEducationChapter={ onDeleteEducationChapter }
              onEducationSelectHandler={ onEducationSelectHandler }
              institutionId={ education.institutionId }
              startDate={ education.startDate }
              endDate={ education.endDate }
              viewMode={ viewMode }
              onOpenCreateNewEducationModal={ onOpenCreateNewEducationModal }
            />
          </Fragment>
        );
      }) }

      {canAdd && (
        <CardActions>
          <Button
            onClick={ onAddNewEducationChapter }
            startIcon={ <PlusCircle /> }
          >
            { translate(STRING_KEYS.ADD_NEW_CHAPTER_EDUCATION) }
          </Button>
        </CardActions>
      )}
    </Card>
  );
};

TalentEducation.defaultProps = {
  onDeleteEducationChapter: undefined,
  onEducationSelectHandler: () => { /* noop */ },
  onAddNewEducationChapter: undefined,
  onOpenCreateNewEducationModal: undefined,
  disabled: false,
};

export default React.memo(TalentEducation);
